export enum ModalTypes {
  Danger = 'danger',
  Success = 'success',
  Primary = 'primary',
}

export interface IInfoModalProps {
  /*Define the type of the modalClasses, If it is success modal or an warning modal before deleting something. Based on this this value there will be change in the flow and design. By default it is success */
  modalType?: ModalTypes;

  /* This is loading state of the info modal*/
  isLoading?: boolean;

  /* This is the Icon that we need to show on the modal*/
  icon: React.ReactNode;

  /* The icon color to modify*/
  iconColor?: string;

  /* This is the title that we need to show on the modal*/
  title: string;

  /* This is required for the Confirm Button text to show in the modal */
  confirmButtonText: string;

  /* This is required for the Cancel Button text to show in the modal */
  cancelButtonText: string;

  showModalHeader?: boolean;

  modalTitle?: string;

  subTitle?: string;

  customStyle?: boolean;

  /* Whether to show the cross button or not in the popup */
  onCrossBtnClick?: () => void;

  /* Callback Method to execute once Confirmed*/
  onConfirm: () => void;

  /* Callback Method to execute once Cancelled*/
  onClose: () => void;
}
